//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Flash from '~/components/Flash.vue';
import axios from 'axios';
export default {
  components: {
    Flash: Flash
  },
  data: function data() {
    return {
      name: 'My APP',
      description: 'Description ',
      isAuth: false,
      websiteLogo: '',
      loggedUser: {},
      loading: false,
      paymentMethod: '',
      showDirectoryLink: false,
      newLoading: false,
      isHawwiyahDomain: false,
      domain: ''
    };
  },
  head: function head() {

    var links = [];
    if (global.getFaviconPath()) {
      links.push({ rel: 'icon', href: global.getFaviconPath() });
    }

    //{rel: 'icon',  type: "x-icon", href: '/PU.ico'}
    return {
      bodyAttrs: {
        class: 'm-0'
      },
      link: links,
      script: [{ src: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyC1rIL9JdJpN9T4LnfhILReBeZ1KM-Lk7A' }],
      titleTemplate: this.$root.trans(global.websiteSettings.extra_info.title)
    };
  },
  created: function created() {
    var _this = this;

    if (process.browser) {
      this.domain = document.location.hostname.replace('.com', '').replace('www.', '');
    }
    if (process.client) {
      this.isAuth = this.$auth.isAuthenticated();
      this.refreshLoggedUser();

      if (window.location.host.match(/hawiyyah.com/i)) {
        this.showDirectoryLink = true;
      }
      if (window.location.host.match(/hawwiyah.com/i)) {
        this.isHawwiyahDomain = true;
      }
    }

    global.getPaymentMethodId().then(function (value) {
      _this.paymentMethod = value;
    });
  },
  mounted: function mounted() {
    if (this.$route.name == 'lang-new-loading') {
      this.newLoading = true;
      document.body.classList.add("new-loading");
    } else {
      this.newLoading = false;
      document.body.classList.remove("new-loading");
    }

    if (global.getLogoPath()) {
      this.websiteLogo = global.getLogoPath();
    }
  },

  computed: {
    lang: function lang() {
      return this.$root._route.params.lang ? this.$root._route.params.lang : 'en';
    }
  },
  methods: {
    loginLogoutCheck: function loginLogoutCheck() {
      if (process.client) {
        this.isAuth = this.$auth.isAuthenticated();
        this.refreshLoggedUser();
      }
    },
    refreshLoggedUser: function refreshLoggedUser() {
      this.$auth.getUser(function (user) {
        this.loggedUser = user;
      }.bind(this));
    },

    websiteName: function websiteName() {
      return global.websiteSettings.extra_info.display_name;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./layouts/green.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./layouts/green.vue
// module chunks = 17